import Cookies from 'js-cookie';

$(() => {
    initCategoryToggle();
    initTimeUntilTomorrow();
    handleVoteFormSubmit();
    handleUrlParams();
    updateVotesCookie();
    updateVoterInputsFromCookie();
});

function initCategoryToggle() {
    const toggleButtons = $('[data-category]'),
        categories = $('.category');

    toggleButtons.on('click', ({ currentTarget }) => {
        const $this = $(currentTarget);
        const categoryName = $this.data('category');

        if (!categoryName) return;

        toggleButtons.removeClass('active');
        $this.addClass('active');

        categoryName === 'all' ? categories.fadeIn() : categories.hide().filter(`#${categoryName}`).fadeIn();
    });
}

function initTimeUntilTomorrow() {
    const timeElement = $('.time');
    const updateTime = () => {
        const now = new Date(),
            diff = new Date().setHours(24, 0, 0, 0) - now,
            format = n => String(Math.floor(n)).padStart(2, '0'),
            timeStr = [diff / 3600000 % 24, diff / 60000 % 60, diff / 1000 % 60].map(format).join(':');

        timeElement.text(timeStr);
    };
    updateTime();
    setInterval(updateTime, 1000);
}

function handleVoteFormSubmit() {
    document.querySelectorAll('.form').forEach(form => {
        form.addEventListener('submit', function(event) {
            event.preventDefault();

            const form = event.target,
                modal = $(form).parents('dialog'),
                data = new FormData(form),
                dataObject = Object.fromEntries(data),
                { firstName, lastName, email } = dataObject;

            $.ajax({
                type: 'POST',
                url: domain + '/api/e-revolutionaries25-vote',
                data: JSON.stringify(Object.fromEntries(data)),
                dataType: 'json',
                contentType: 'application/json'
            }).done((data) => {
                    let votes = Cookies.get('votes') ? JSON.parse(Cookies.get('votes')) : {},
                        secondsUntilMidnight = getSecondsUntilMidnight();

                    votes[dataObject.category] = true;
                    setCategoryDisabled(dataObject.category);
                    Cookies.set('voter', JSON.stringify({ firstName, lastName, email }));
                    Cookies.set('votes', JSON.stringify(votes), { expires: secondsUntilMidnight / 86400 });
                    updateVoterInputsFromCookie();

                    $(form).parent().html(`<div class="fw-bold font-size-20">Thank you for your vote! 💜</div>
                                  <div>Submit your vote now in another category <br class="mobile-hide"> or come back tomorrow to vote again.</div>
                                  <div class="modal-close-counter color-dark-gray p-absolute" style="right:2rem;bottom:1rem;">5</div>`);
                    closeModalAfterSeconds(modal, 5);
                })
                .fail((xhr) => {
                    let response = xhr?.responseJSON ? xhr?.responseJSON?.defaultMessage : `Something went wrong. <div class="font-size-12 fw-normal mt-1">Please check back later or contact our support.</div>`;
                    $(form).parent().html(`<div class="fw-bold mt-4 mb-2">${response}</div>
                                          <div class="modal-close-counter color-dark-gray p-absolute" style="right:2rem;bottom:1rem;">5</div>`);
                    closeModalAfterSeconds(modal, 5);
                });
        });
    });
}

function updateVotesCookie() {
    const votes = Cookies.get('votes') ? JSON.parse(Cookies.get('votes')) : {};

    for (const category in votes) {
        if (votes[category]) setCategoryDisabled(category);
    }
}

function updateVoterInputsFromCookie() {
    const voterCookie = Cookies.get('voter');

    if (voterCookie) {
        const voterInfo = JSON.parse(voterCookie);
        $('[name="firstName"]').val(voterInfo.firstName);
        $('[name="lastName"]').val(voterInfo.lastName);
        $('[name="email"]').val(voterInfo.email);
    }
}

function setCategoryDisabled(category) {
    const element = document.getElementById(category);
    if (element) element.classList.add('category-disabled');
}

function getSecondsUntilMidnight() {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    return (midnight - now) / 1000;
}

function closeModalAfterSeconds(modal, seconds) {
    let counter = seconds;

    const interval = setInterval(() => {
        counter--;
        modal.find('.modal-close-counter').text(counter);

        if (counter < 1) {
            clearInterval(interval);
            modal[0].close();
        }
    }, 1000);
}

function handleUrlParams() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const paramName = 'voteId';

    if (params.has(paramName)) {
        const paramValue = params.get(paramName);
        const dialog = Array.from(document.querySelectorAll('dialog')).find(dlg => dlg.id.includes(paramValue));
        const category = dialog.id.split('-')[1];

        if (dialog) {
            const votes = Cookies.get('votes') ? JSON.parse(Cookies.get('votes')) : {};
            if (!(category in votes)) document.getElementById(dialog.id).showModal();
        }
    }
}
